<template>
  <el-card style="background-color:#ecf4e3">
    <el-row>
      <el-col
        :xs="24"
        :span="12"
      >
        <p><b>Quoted Accepted Amount: <Money :amount="estimated_contract" /></b> </p>
        <p>
          Variation: <Money :amount="additional_sales" />
          <br>Total Sale:  <Money :amount="total_sale_price" />
          <br>Total Quote:<Money :amount="total_contract" />  <br>
          <b>Matched Quote:   <Money
            v-if="proposal_matched_quote > 0"
            :amount="proposal_matched_quote"
          />  <i
            v-show="proposal_matched_quote > 0"
            class="el-icon-check"
          /></b>
        </p>
      </el-col>
      <el-col
        :xs="24"
        :span="12"
      >
        <p style="text-align:right;font-weight:bold">
          Sales Balance Pending: <Money :amount="balance_pending" />
        </p>
        <div v-if="parent_sale.invoice_based_wf==false">
          <p style="text-align:right">
            Invoiced:  <Money :amount="parent_sale.total_contract" />
          </p>
        </div>
        <div
          v-else
          style="text-align:right"
        >
          <li
            v-for="(wf_sale,index) in wf_sales"
            :key="index"
            style="list-style:none"
            :class="activated(wf_sale.key)"
          >
            <span style="text-align:right">
              Invoiced {{ index+1 }}:

              <Money :amount="wf_sale.sale.total_contract" /></span>
          </li>
        </div>
      </el-col>
    </el-row>
    <el-row style="background-color:#e6e7e8; padding:5px;">
      <el-col
        :xs="{span: 24, offset: 0}"
        :offset="0"
        :span="24"
      >
        <span style="padding-right:20px;">  Total Labour Cost: <Money :amount="labour_cost" />
        </span>
        <span style="padding-right:20px;"> Total Stock Cost: <Money :amount="stock_cost" />
        </span>
        <span style="padding-right:20px;">Total Cost: <Money :amount="total_cost" />
        </span>
        <span style="padding-right:20px;"> Profit: <Money :amount="gross_profit" /></span>
        <span style="padding-right:20px;">    <b>Gross profit</b>
          <b><Percent
            :dividend="gross_profit"
            :divisor="total_sale_price"
          /></b>

        </span>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import SalesCostMixin from '../../../mixins/SalesCostMixin';

import { sale_store } from '../../../store/modules/sale_store';

import Money from '../../../components/shared/Money';
import Percent from '../../../components/shared/Percent';
import {mapGetters} from 'vuex';

export default {
  name: 'Information',
  store: sale_store,
  components: {
    Money,
    Percent
  },

  mixins: [SalesCostMixin],
  props: {
    proposal_matched_quote: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'get_parent_sale',
      'get_wf_sales',
      'get_current_sale_key'
    ]),

    parent_sale: {
      get() {
        return this.get_parent_sale;
      },
    },
    wf_sales: {
      get() {
        return this.get_wf_sales;
      },
    },
    current_sale_key: {
      get() {
        return this.get_current_sale_key;
      },
    },
    estimated_contract() {
      return parseFloat(this.parent_sale.estimated_contract);
    },
    total_contract() {
      return parseFloat(this.parent_sale.total_contract);
    },
    additional_sales() {
      return parseFloat(this.total_contract) - parseFloat(this.estimated_contract);
    },
    balance_pending() {
      return parseFloat(this.total_contract) - this.total_invoice_approved;
    },
    total_invoice_approved() {
      let total_contract = 0;
      if(this.parent_sale.invoice_based_wf==false) {
        if(this.parent_sale.approved == true) {
          total_contract = parseFloat(this.parent_sale.total_contract);
        }
      }
      else {
        this.wf_sales.forEach((wf_sale) => {
          if(wf_sale.sale.approved == true) {
            total_contract += parseFloat(wf_sale.sale.total_contract);
          }
        });
      }
      return total_contract;
    },
    activated() {
      return key => {
        if (this.current_sale_key == key) {
          return 'gray__transparent';
        }
        return '';
      };
    }
  },
};

</script>


